import React from 'react';
import Avatar from '@mui/material/Avatar';
import { getIcon, isActiveMenu } from '../utils';
import * as S from './styles';
const AdvancedSubMenu = ({ item }) => {
    const { href, title, description, icon, iconColor, tag, groupName } = item;
    const IconComponent = getIcon(icon);
    return (React.createElement(React.Fragment, null,
        groupName ? React.createElement(S.GroupName, null, groupName) : null,
        React.createElement(S.CustomLink, { href: href, underline: "none", "$isActive": isActiveMenu(href) },
            React.createElement(S.Wrapper, null,
                React.createElement("div", { className: "iconWrapper" }, IconComponent ? (React.createElement(Avatar, { sx: { bgcolor: iconColor, width: 46, height: 46 } }, IconComponent)) : (React.createElement(Avatar, { sx: { width: 46, height: 46 }, src: icon }))),
                React.createElement("div", { className: "mainWrapper" },
                    React.createElement("span", { className: "title" },
                        title,
                        !tag ? null : React.createElement(S.Tag, null, tag)),
                    React.createElement("span", { className: "description" }, description))))));
};
export default AdvancedSubMenu;
//# sourceMappingURL=index.js.map